import { OrganizationUnitService } from "@/api/service-proxies";
export const organizationUnitService = new OrganizationUnitService();
